// Adresse der oeffentlichen Seite einer Anzeige — die Stellen-App verlinkt
// darauf, die Bearbeiten-Maske zeigt sie zum Nachsehen.
export const jobPublicPath = slug => `/stellenangebote/${slug}/`
